import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react/components/Modal';
import SweetAlert from 'react/components/SweetAlert';
import CircleLoader from 'react/components/CircleLoader';
import MealIdeaGroupList from './MealIdeaGroupList';
import MealIdeaPanel from './MealIdeaPanel';
import { clearSelectedMealIdea, deleteMealIdea, deleteMealIdeaGroup, loadMealIdeas, selectMealIdea } from 'redux/actions/mealIdeas';
import { selectMealIdeasLoaded, selectMealIdeasLoading, selectSelectedIdea } from '../../../redux/food/selectors';

/**
 * The meal idea groups, on the Meal Ideas tab and in the column beside the calendar, with the
 * store's selected idea open in a popup. A popup opened from a row grows out of it, and shrinks back
 * into it on closing.
 */
export default function MealIdeasTab() {
	const dispatch = useDispatch();
	const loaded = useSelector(selectMealIdeasLoaded);
	const loading = useSelector(selectMealIdeasLoading);
	const error = useSelector((state) => state.mealIdeas.error);
	const idea = useSelector(selectSelectedIdea);
	const [pendingDelete, setPendingDelete] = useState(null);
	const [origin, setOrigin] = useState(null);

	const openIdea = (ideaId, row) => {
		setOrigin(row);
		dispatch(selectMealIdea(ideaId));
	};

	const closePopup = () => {
		setOrigin(null);
		dispatch(clearSelectedMealIdea());
	};

	useEffect(() => {
		if(!loaded && !loading) {
			dispatch(loadMealIdeas());
		}
	}, []);

	const onRequestDelete = (kind, id, name) => setPendingDelete({ kind, id, name });

	const confirmDelete = () => {
		if(!pendingDelete) {
			return Promise.resolve();
		}
		const { kind, id } = pendingDelete;
		return dispatch(kind === 'idea' ? deleteMealIdea(id) : deleteMealIdeaGroup(id));
	};

	return (
		<div className='row meal_ideas_row'>
			<SweetAlert
				isOpen={!!pendingDelete}
				onCancel={() => setPendingDelete(null)}
				onConfirm={confirmDelete}
				showCancelButton
				showConfirmButton
				icon='warning'
			>
				{pendingDelete && pendingDelete.kind === 'group' ?
					<span>Delete the group {pendingDelete.name}? Its ideas are kept.</span> :
					<span>Delete {pendingDelete ? pendingDelete.name : 'this idea'} from every group?</span>
				}
			</SweetAlert>

			{!!idea &&
			<Modal className='meal_idea_modal' origin={origin} onClose={closePopup}>
				{(close) => <MealIdeaPanel key={idea.id} idea={idea} onClose={close} />}
			</Modal>
			}

			<div className='col s12'>
				{!!error && <p className='red-text'>{error}</p>}
				{!loaded && loading ? <CircleLoader /> : <MealIdeaGroupList onRequestDelete={onRequestDelete} onOpenIdea={openIdea} />}
			</div>
		</div>
	);
}
